<template>
    <div>
        <span>投递职位：
            <span v-if="data.positionName">{{data.positionName}}</span>
            <span v-if="data.willNature=='1'">实习</span>
            <el-divider direction="vertical"></el-divider>
        </span>
        <span v-if="data.applyTime">{{data.applyTime}}投递</span>
        <el-switch
                v-model="value"
                active-color="#13ce66"
                inactive-color="#ff4949">
        </el-switch>
        <el-button type="primary" size="small" round @click="openDialog">下载简历</el-button>
    </div>
</template>
<script>
    export default {
        name: 'statusBar', // 简历状态栏
        props: ['data'],
        data(){
            return{
                value: false,
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>